// @flow

import { createAction, handleAction } from 'redux-actions'

/**
 * Action for updating the extent in the store
 */
export const currentExtentsUpdate = createAction(
  'EXTENTS/CURRENT/UPDATE',
  (extent: [number, number]) => extent
)

export const extents = handleAction(
  currentExtentsUpdate,
  (state, { payload }) => payload,
  [0, 15]
)

export const overallExtentsUpdate = createAction(
  'EXTENTS/OVERALL/UPDATE',
  (extent: [number, number]) => extent
)

export const overallExtents = handleAction(
  overallExtentsUpdate,
  (state, { payload }) => payload,
  [0, 30]
)

export type Extents = [number, number]



// WEBPACK FOOTER //
// ./src/components/scale/reducer.js